import { ScheduleGridHeaderCellProps } from '@intrasync/react';

interface AccountingScheduleRightHeaderCellProps
  extends ScheduleGridHeaderCellProps {
  currentHeader: {
    title: string;
    key: string;
    headerKey?: string;
  };
}

const AccountingScheduleRightHeaderCell = (
  props: AccountingScheduleRightHeaderCellProps
) => {
  const { currentHeader } = props;

  // Determine header color based on type
  const getHeaderColor = (title: string) => {
    if (title.includes("Invoice")) return "#2e7d32"; // Darker green for invoices
    if (title.includes("Bill")) return "#d32f2f"; // Darker red for bills
    return "#1976d2"; // Blue for other types
  };

  const getHeaderBackgroundColor = (title: string) => {
    if (title.includes("Invoice")) return "#e8f5e8"; // Light green background
    if (title.includes("Bill")) return "#ffebee"; // Light red background
    return "#e3f2fd"; // Light blue background
  };

  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        ...props.style,
        ...props.styles,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px 8px",
        backgroundColor: getHeaderBackgroundColor(currentHeader?.title || ""),
        borderRadius: "4px",
        minHeight: "50px",
      }}
    >
      <div
        style={{
          fontWeight: "700",
          color: getHeaderColor(currentHeader?.title || ""),
          textAlign: "center",
          fontSize: "13px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {currentHeader?.title || "Transactions"}
      </div>
    </div>
  );
};

export default AccountingScheduleRightHeaderCell;
